import script from "./Direct-Debit-Mandate.vue?vue&type=script&setup=true&lang=js"
export * from "./Direct-Debit-Mandate.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__